module.exports = new __parcel__URL__("metroid-dread.32b103fa.jpg").toString();